import { format as formatDate, setSeconds, startOfToday } from 'date-fns';

import { PLAY_TIME_FORMAT, PLAY_TIME_FORMAT_WITH_HOUR } from '../constants';

export const formatSeconds = (seconds: number, format?: string): string =>
  formatDate(
    setSeconds(startOfToday(), Math.round(seconds)),
    format ?? (seconds >= 3600 ? PLAY_TIME_FORMAT_WITH_HOUR : PLAY_TIME_FORMAT)
  );
